"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8984],{

/***/ 45628:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/upload-file.5e07a440.png","height":43,"width":36,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAG1BMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACUUeIgAAAACXRSTlMBhXsdEaWbPmTzii/gAAAACXBIWXMAAAsTAAALEwEAmpwYAAAALklEQVR4nCXJwQ0AMAjDQCcQ2v0nrlDvaQN9m+UYaGWipo5GpwBF/89+qNpqLT8QWABzUcHklQAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 78984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(69396);
/* harmony import */ var _home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(39803);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(282);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(30585);
/* harmony import */ var _material_ui_styles__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(11719);
/* harmony import */ var _components_QuattrLogoSpinner__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53056);
/* harmony import */ var _assets_images_upload_file_png__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45628);
/* harmony import */ var _components_CustomerDropDownWithLock__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62412);
/* harmony import */ var _utility_cr_common__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46236);
/* harmony import */ var react_google_recaptcha__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34853);
/* harmony import */ var _material_ui_icons_Lock__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(44080);
/* harmony import */ var _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66306);
/* harmony import */ var _components_ToolsStyleWrapper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97344);
/* harmony import */ var _utility_common__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5969);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(31955);
/* harmony import */ var _components_SkipCaptcha__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(98950);
/* harmony import */ var react_dropzone__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(71239);
/* harmony import */ var _utility_services_customHooks__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(89147);
/* harmony import */ var _components_CreditsInfo__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(98910);
/* harmony import */ var browser_image_compression__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(40221);
























var useStyles = (0,_material_ui_styles__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(function(theme) {
    return {
        buttonGroup: {
            display: "flex",
            justifyContent: "flex-end"
        },
        dropZone: {
            width: "100%",
            height: "60px",
            marginBottom: "8px",
            background: "rgba(33, 33, 33, 0.08)",
            border: "1px dashed rgba(0, 0, 0, 0.87)",
            boxSizing: "border-box",
            borderRadius: "4px !important",
            textAlign: "center",
            alignContent: "center",
            cursor: "pointer"
        },
        dropZoneText: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({
            fontSize: "16px",
            textAlign: "center",
            letterSpacing: "0.18px",
            color: "rgba(0, 0, 0, 0.6)",
            margin: "0px"
        }, theme.breakpoints.down(400), {
            fontSize: "11px"
        }),
        dropZoneTextShortened: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({
            fontSize: "16px",
            textAlign: "center",
            letterSpacing: "0.18px",
            color: "rgba(0, 0, 0, 0.6)",
            margin: "0px",
            overflow: "hidden",
            whiteSpace: "nowrap",
            maxWidth: "400px",
            textOverflow: "ellipsis"
        }, theme.breakpoints.down(400), {
            fontSize: "11px",
            maxWidth: "230px"
        })
    };
});
var ImageAltTextGenerator = function(param) {
    var classes = param.classes, setShowSignUpPage = param.setShowSignUpPage, user = param.user, hasValidSubscription = param.hasValidSubscription, resetLockedGrace = param.resetLockedGrace, enableLockedOption = param.enableLockedOption, handleResetUsage = param.handleResetUsage, _isQwaDashboard = param.isQwaDashboard, isQwaDashboard = _isQwaDashboard === void 0 ? false : _isQwaDashboard, _isCreditsShown = param.isCreditsShown, isCreditsShown = _isCreditsShown === void 0 ? false : _isCreditsShown, _creditsRemaining = param.creditsRemaining, creditsRemaining = _creditsRemaining === void 0 ? 0 : _creditsRemaining, _usagePerDay = param.usagePerDay, usagePerDay = _usagePerDay === void 0 ? 0 : _usagePerDay, setShowBuyOnePass = param.setShowBuyOnePass, setIsRedirectToWebflow = param.setIsRedirectToWebflow, _setShowMinimumCreditsNeededMsg = param.setShowMinimumCreditsNeededMsg, setShowMinimumCreditsNeededMsg = _setShowMinimumCreditsNeededMsg === void 0 ? function(a) {} : _setShowMinimumCreditsNeededMsg, setShowVerifyEmailPopup = param.setShowVerifyEmailPopup, _freeToolsUsage = param.freeToolsUsage, freeToolsUsage = _freeToolsUsage === void 0 ? 0 : _freeToolsUsage, _showFreeToolsUsage = param.showFreeToolsUsage, showFreeToolsUsage = _showFreeToolsUsage === void 0 ? false : _showFreeToolsUsage, _isCorpEmail = param.isCorpEmail, isCorpEmail = _isCorpEmail === void 0 ? false : _isCorpEmail;
    var ownClasses = useStyles();
    var qttr_tools_auth = js_cookie__WEBPACK_IMPORTED_MODULE_11__/* ["default"].get */ .Z.get("qttr_tools_auth");
    var qttr_tools_daypass_auth = js_cookie__WEBPACK_IMPORTED_MODULE_11__/* ["default"].get */ .Z.get("qttr_tools_daypass_auth");
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), keyword = ref[0], setKeyword = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), description = ref1[0], setDescription = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(3), numTags = ref2[0], setNumTags = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), generatedTitles = ref3[0], setGeneratedTitles = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), imageBase64 = ref4[0], setImageBase64 = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), fileData = ref5[0], setFileData = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), dropBoxError = ref6[0], setDropBoxError = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loading = ref7[0], setLoading = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), error = ref8[0], setError = ref8[1];
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), copied = ref9[0], setCopied = ref9[1];
    var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), recaptchaValue = ref10[0], setRecaptchaValue = ref10[1];
    var ref11 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), captchaError = ref11[0], setCaptchaError = ref11[1];
    var ref12 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(1), creditsNeeded = ref12[0], setCreditsNeeded = ref12[1];
    var inputSelectionRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var session = (0,_utility_services_customHooks__WEBPACK_IMPORTED_MODULE_14__/* .useSession */ .kP)();
    var handleRecaptchaChange = function(value) {
        setRecaptchaValue(value);
        setCaptchaError("");
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .trackAnalyticsEvent */ .ec)({
            isAnonymousUser: !user,
            payload: {
                label: "Visited Free Tool",
                component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_NAME.image_alt_text_generator */ .vG.image_alt_text_generator,
                tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_optimization */ ._V.ai_content_optimization,
                isQwaDashboard: isQwaDashboard
            }
        });
    }, []);
    var handleWriteTitleTag = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var res, axiosError;
            return _home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        setLoading(true);
                        if (!(!fileData && !keyword)) {
                            _ctx.next = 5;
                            break;
                        }
                        setError("keyword");
                        return _ctx.abrupt("return");
                    case 5:
                        if (recaptchaValue || qttr_tools_auth || user) {
                            _ctx.next = 8;
                            break;
                        }
                        setCaptchaError("recaptchaValue");
                        return _ctx.abrupt("return");
                    case 8:
                        setError("");
                        setCaptchaError("");
                        _ctx.next = 12;
                        return (0,_utility_cr_common__WEBPACK_IMPORTED_MODULE_6__/* .fetchAIBasedContent */ .LK)({
                            promptFor: "PUBLIC_UTILITY.GENERATE_ALT_TEXT",
                            promptConfig: {
                                noOf: numTags,
                                content: description,
                                specialInstructions: description,
                                mainKeyword: keyword,
                                image_link: imageBase64
                            },
                            tokenLimit: 3500,
                            isPublicApi: true,
                            reCAPTCHAToken: recaptchaValue
                        });
                    case 12:
                        res = _ctx.sent;
                        if (res) {
                            (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .trackAnalyticsEvent */ .ec)({
                                eventFor: "button",
                                buttonText: "",
                                counterName: "".concat(_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_optimization */ ._V.ai_content_optimization, " Outputs"),
                                isAddCount: true,
                                user: user,
                                isAnonymousUser: !user,
                                payload: {
                                    label: "Generate Output",
                                    component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                                    screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                                    tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_NAME.image_alt_text_generator */ .vG.image_alt_text_generator,
                                    tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_optimization */ ._V.ai_content_optimization,
                                    number_suggestions: numTags,
                                    special_instructions_yn: description ? "Yes" : "No",
                                    isQwaDashboard: isQwaDashboard,
                                    isImageAdded: imageBase64 ? true : false,
                                    creditsConsumed: creditsNeeded ? creditsNeeded : 1
                                }
                            });
                            if (handleResetUsage) {
                                handleResetUsage();
                            }
                        }
                        setGeneratedTitles(res || "no title generated");
                        if (resetLockedGrace) {
                            resetLockedGrace();
                            setNumTags(3);
                        }
                        _ctx.next = 23;
                        break;
                    case 18:
                        _ctx.prev = 18;
                        _ctx.t0 = _ctx["catch"](0);
                        axiosError = _ctx.t0;
                        if (axiosError === null || axiosError === void 0 ? void 0 : axiosError.response) {
                            if (axiosError.response.status === 403) {
                                setShowSignUpPage(_components_ToolsStyleWrapper__WEBPACK_IMPORTED_MODULE_9__/* .CONTINUE_USING_TEXT */ .gt, {
                                    tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_NAME.image_alt_text_generator */ .vG.image_alt_text_generator,
                                    tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_optimization */ ._V.ai_content_optimization
                                });
                                (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .trackAnalyticsEvent */ .ec)({
                                    eventFor: "button",
                                    isAnonymousUser: !user,
                                    payload: {
                                        label: "Reached your maximum usage limit",
                                        component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                                        screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                                        tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_NAME.image_alt_text_generator */ .vG.image_alt_text_generator,
                                        tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_optimization */ ._V.ai_content_optimization,
                                        isQwaDashboard: isQwaDashboard,
                                        isImageAdded: imageBase64 ? true : false
                                    }
                                });
                            } else if ((axiosError === null || axiosError === void 0 ? void 0 : axiosError.response.status) === 500) {
                                setDropBoxError("Failed to process the image. Please try again.");
                                (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .trackAnalyticsEvent */ .ec)({
                                    eventFor: "button",
                                    isAnonymousUser: !user,
                                    payload: {
                                        label: "Failed to process the image. Please try again.",
                                        component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                                        screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                                        tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_NAME.image_alt_text_generator */ .vG.image_alt_text_generator,
                                        tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_optimization */ ._V.ai_content_optimization,
                                        isQwaDashboard: isQwaDashboard,
                                        isImageAdded: imageBase64 ? true : false
                                    }
                                });
                            }
                        }
                        console.error("handleWriteTitleTag::error", _ctx.t0);
                    case 23:
                        _ctx.prev = 23;
                        setRecaptchaValue(null);
                        (0,_utility_common__WEBPACK_IMPORTED_MODULE_10__/* .resetCaptcha */ .Ler)();
                        setLoading(false);
                        return _ctx.finish(23);
                    case 28:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    18,
                    23,
                    28
                ]
            ]);
        }));
        return function handleWriteTitleTag() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCopyText = function() {
        var inputElement = inputSelectionRef === null || inputSelectionRef === void 0 ? void 0 : inputSelectionRef.current;
        if (inputElement) {
            var ref;
            var copiedText = inputElement === null || inputElement === void 0 ? void 0 : (ref = inputElement.value) === null || ref === void 0 ? void 0 : ref.substring((inputElement === null || inputElement === void 0 ? void 0 : inputElement.selectionStart) || 0, (inputElement === null || inputElement === void 0 ? void 0 : inputElement.selectionEnd) || 0);
            if (copiedText) {
                navigator.clipboard.writeText(copiedText);
                setCopied(true);
                (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .trackAnalyticsEvent */ .ec)({
                    eventFor: "button",
                    buttonText: "",
                    counterName: "Outputs Accepted",
                    isAddCount: true,
                    user: user,
                    isAnonymousUser: !user,
                    payload: {
                        label: "Copy Generated Output",
                        component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                        screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                        tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_NAME.image_alt_text_generator */ .vG.image_alt_text_generator,
                        tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_optimization */ ._V.ai_content_optimization,
                        number_suggestions: numTags,
                        special_instructions_yn: description ? "Yes" : "No",
                        isQwaDashboard: isQwaDashboard,
                        isImageAdded: imageBase64 ? true : false,
                        isManualCopy: true
                    }
                });
            } else {
                navigator.clipboard.writeText(generatedTitles);
                setCopied(true);
                (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .trackAnalyticsEvent */ .ec)({
                    eventFor: "button",
                    buttonText: "",
                    counterName: "Outputs Accepted",
                    isAddCount: true,
                    user: user,
                    isAnonymousUser: !user,
                    payload: {
                        label: "Copy Generated Output",
                        component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                        screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                        tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_NAME.image_alt_text_generator */ .vG.image_alt_text_generator,
                        tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_optimization */ ._V.ai_content_optimization,
                        number_suggestions: numTags,
                        special_instructions_yn: description ? "Yes" : "No",
                        isQwaDashboard: isQwaDashboard,
                        isImageAdded: imageBase64 ? true : false
                    }
                });
            }
        }
        setTimeout(function() {
            setCopied(false);
        }, 2000); // Change the text back to 'Copy Text' after 2 seconds
    };
    var numbers = [
        3,
        5,
        10
    ];
    // Convert the array items to a mixed array of a number and objects
    var NumberOptions = numbers.map(function(number) {
        // Keep the first item as a number
        if ([
            3
        ].includes(number)) {
            return number;
        }
        // Convert the rest to objects, include a React component for the icon
        return {
            name: number,
            requireLogin: !hasValidSubscription && !enableLockedOption,
            icon: !hasValidSubscription && !enableLockedOption ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons_Lock__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                className: classes.unlockIcon
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "18",
                height: "18",
                viewBox: "0 0 18 18",
                fill: "none",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M9 12.9525L13.635 15.75L12.405 10.4775L16.5 6.93L11.1075 6.4725L9 1.5L6.8925 6.4725L1.5 6.93L5.595 10.4775L4.365 15.75L9 12.9525Z",
                    fill: "#FFC72C"
                })
            })
        };
    });
    var onDrop = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(acceptedFiles, fileRejections) {
            var file, fileSizeMB, base64, newFile;
            return _home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(!hasValidSubscription && !enableLockedOption)) {
                            _ctx.next = 3;
                            break;
                        }
                        setShowSignUpPage("'enable {value} Alt Text Suggestions'", {
                            tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_NAME.image_alt_text_generator */ .vG.image_alt_text_generator,
                            tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_optimization */ ._V.ai_content_optimization
                        });
                        return _ctx.abrupt("return");
                    case 3:
                        setDropBoxError("");
                        // Display error for rejected files
                        fileRejections.forEach(function(param) {
                            var errors = param.errors;
                            return errors.forEach(function(param) {
                                var code = param.code;
                                if (code === "file-invalid-type") {
                                    setFileData("");
                                    setImageBase64("");
                                    setDropBoxError("This image format is not supported. Please upload the image in supported format.");
                                } else if (code === "file-too-large") {
                                    setFileData("");
                                    setImageBase64("");
                                    setDropBoxError("The image size exceeds 8MB. Please upload a smaller file to proceed.");
                                }
                            });
                        });
                        file = acceptedFiles[0];
                        if (file) {
                            _ctx.next = 8;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 8:
                        fileSizeMB = file.size / 1024 / 1024;
                        _ctx.prev = 9;
                        ;
                        if (!(fileSizeMB > 5.6)) {
                            _ctx.next = 21;
                            break;
                        }
                    case 12:
                        _ctx.next = 14;
                        return (0,browser_image_compression__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(file, {
                            maxSizeMB: file.size / 1024 / 1024 - 1,
                            maxWidthOrHeight: 1024,
                            useWebWorker: true
                        });
                    case 14:
                        newFile = _ctx.sent;
                        _ctx.next = 17;
                        return browser_image_compression__WEBPACK_IMPORTED_MODULE_16__/* ["default"].getDataUrlFromFile */ .Z.getDataUrlFromFile(newFile);
                    case 17:
                        base64 = _ctx.sent;
                    case 18:
                        if (base64.length * 3 / 4 / (1024 * 1024) > 7) {
                            _ctx.next = 12;
                            break;
                        }
                    case 19:
                        _ctx.next = 24;
                        break;
                    case 21:
                        _ctx.next = 23;
                        return browser_image_compression__WEBPACK_IMPORTED_MODULE_16__/* ["default"].getDataUrlFromFile */ .Z.getDataUrlFromFile(file);
                    case 23:
                        // Convert smaller files directly to Base64
                        base64 = _ctx.sent;
                    case 24:
                        // Update file and Base64 data
                        setFileData(file);
                        setImageBase64(base64);
                        (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .trackAnalyticsEvent */ .ec)({
                            eventName: "Uploaded Image file",
                            eventFor: "btn",
                            payload: {
                                label: "Uploaded Image file",
                                component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                                screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                                tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_NAME.image_alt_text_generator */ .vG.image_alt_text_generator,
                                tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_optimization */ ._V.ai_content_optimization
                            }
                        });
                        _ctx.next = 33;
                        break;
                    case 29:
                        _ctx.prev = 29;
                        _ctx.t0 = _ctx["catch"](9);
                        console.error("Image compression error:", _ctx.t0);
                        setDropBoxError("Failed to process the image. Please try again.");
                    case 33:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    9,
                    29
                ]
            ]);
        }));
        return function(acceptedFiles, fileRejections) {
            return _ref.apply(this, arguments);
        };
    }(), [
        hasValidSubscription,
        enableLockedOption,
        setShowSignUpPage
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var promptFor = _utility_common__WEBPACK_IMPORTED_MODULE_10__/* .PAID_TOOLS_PROMPT_FOR.IMAGE_ALT_TEXT_GENERATOR */ .rMq.IMAGE_ALT_TEXT_GENERATOR;
        var promptConfig = {
            noOf: numTags,
            content: description,
            specialInstructions: description,
            mainKeyword: keyword,
            image_link: imageBase64
        };
        setCreditsNeeded((0,_utility_common__WEBPACK_IMPORTED_MODULE_10__/* .getToolsUsageCreditsNeeded */ .Nmb)(promptFor, promptConfig));
    }, [
        user,
        description,
        keyword,
        numTags,
        imageBase64
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: generatedTitles ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: classes.container,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                    inputRef: inputSelectionRef,
                    fullWidth: true,
                    multiline: true,
                    rows: 8,
                    margin: "normal",
                    placeholder: "Generated Title Tag",
                    value: generatedTitles,
                    className: "".concat(classes.textAreaInput, " no-border background-gray"),
                    maxRows: 8,
                    InputProps: {
                        style: {
                            borderRadius: "4px !important",
                            padding: "16px"
                        }
                    },
                    minRows: 5,
                    variant: "outlined",
                    onCopy: handleCopyText
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: classes.buttonGroup,
                    style: {
                        marginTop: "16px"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                            className: "".concat(classes.toolsYellowCTA, " ").concat(classes.toolsOutlinedCTA, " ").concat(classes.button),
                            disabled: loading,
                            style: {
                                float: "right"
                            },
                            onClick: function() {
                                setGeneratedTitles("");
                                (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .trackAnalyticsEvent */ .ec)({
                                    eventName: "Clicked on Go back",
                                    payload: {
                                        label: "Clicked on Go back"
                                    }
                                });
                            },
                            children: "Go back"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                            className: "".concat(classes.toolsYellowCTA, " ").concat(classes.button),
                            disabled: loading,
                            style: {
                                float: "right"
                            },
                            onClick: handleCopyText,
                            children: copied ? "Copied!" : "Copy Text"
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: classes.container,
                children: [
                    loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_QuattrLogoSpinner__WEBPACK_IMPORTED_MODULE_3__/* .QuattrLogoSpinner */ .h, {
                        classes: classes
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                        fullWidth: true,
                        label: "Enter Topic or Main Keyword",
                        value: keyword,
                        className: "".concat(classes.textAreaInput, " no-border mb-0"),
                        onChange: function(e) {
                            return setKeyword(e.target.value);
                        },
                        InputProps: {
                            style: {
                                backgroundColor: "#fff",
                                borderRadius: "4px !important"
                            }
                        },
                        variant: "outlined",
                        error: !!error,
                        helperText: error.includes("keyword") ? "* Required" : error.includes("Please sign up") ? error : ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                        fullWidth: true,
                        placeholder: "Describe image contents\nEx. An image collage of top Christmas sweater styles",
                        multiline: true,
                        className: classes.textAreaInput,
                        value: description,
                        maxRows: 5,
                        InputProps: {
                            style: {
                                backgroundColor: "#fff",
                                borderRadius: "4px !important",
                                padding: "16px"
                            },
                            disableUnderline: true
                        },
                        minRows: 5,
                        variant: "filled",
                        onChange: function(e) {
                            return setDescription(e.target.value);
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                        className: classes.orText,
                        children: "OR"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_dropzone__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        onDrop: onDrop,
                        accept: ".png,.jpg,.jpeg,.webp",
                        maxSize: 8388600,
                        children: function(param) {
                            var getRootProps = param.getRootProps, getInputProps = param.getInputProps, isDragActive = param.isDragActive;
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)({
                                        className: ownClasses.dropZone
                                    }, getRootProps()), {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)({}, getInputProps()), {
                                                disabled: !hasValidSubscription && !enableLockedOption
                                            })),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                onClick: function() {
                                                    if (!hasValidSubscription && !enableLockedOption) {
                                                        setShowSignUpPage("'enable {value} Alt Text Suggestions'", {
                                                            tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_NAME.image_alt_text_generator */ .vG.image_alt_text_generator,
                                                            tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_optimization */ ._V.ai_content_optimization
                                                        });
                                                    }
                                                },
                                                style: {
                                                    display: "flex",
                                                    justifyContent: "center"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                                        height: 15,
                                                        width: 15,
                                                        src: _assets_images_upload_file_png__WEBPACK_IMPORTED_MODULE_4__/* ["default"].src */ .Z.src,
                                                        style: {
                                                            marginRight: "15px",
                                                            marginLeft: "10px",
                                                            alignSelf: "center"
                                                        }
                                                    }),
                                                    fileData && (fileData === null || fileData === void 0 ? void 0 : fileData.path) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                        className: ownClasses.dropZoneTextShortened,
                                                        children: fileData.path
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                        className: ownClasses.dropZoneText,
                                                        children: "Drag and drop your image or click to upload"
                                                    }),
                                                    !hasValidSubscription && !enableLockedOption ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons_Lock__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                                        className: classes.unlockIcon,
                                                        style: {
                                                            marginLeft: "10px"
                                                        }
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        style: {
                                                            marginLeft: "10px"
                                                        },
                                                        width: "18",
                                                        height: "18",
                                                        viewBox: "0 0 18 18",
                                                        fill: "none",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                                                            "fill-rule": "evenodd",
                                                            "clip-rule": "evenodd",
                                                            d: "M9 12.9525L13.635 15.75L12.405 10.4775L16.5 6.93L11.1075 6.4725L9 1.5L6.8925 6.4725L1.5 6.93L5.595 10.4775L4.365 15.75L9 12.9525Z",
                                                            fill: "#FFC72C"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: "pd-15 mb-10",
                                        children: dropBoxError ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                            className: "negative-text",
                                            children: dropBoxError
                                        }) : null
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: "pd-15 mb-10",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                            style: {
                                                margin: "0px 0px 24px 0px",
                                                color: "rgba(0, 0, 0, 0.6)",
                                                fontWeight: "500",
                                                fontSize: "12px"
                                            },
                                            children: [
                                                "Supported File Format: PNG, JPG, JPEG, WEBP; \xa0 Maximum File Size: 8MB",
                                                " "
                                            ]
                                        })
                                    })
                                ]
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_CustomerDropDownWithLock__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        label: "Number of Alt Text Suggestions",
                        value: numTags,
                        options: NumberOptions,
                        onChange: function(event) {
                            var value = event.target.value;
                            var option = NumberOptions.find(function(o) {
                                return typeof o === "object" && "name" in o ? o.name === value : o === value;
                            });
                            if (option && (typeof option === "number" || !(typeof option == "object" && option.requireLogin))) {
                                setNumTags(value);
                            } else {
                                if (setShowSignUpPage) {
                                    setShowSignUpPage("'enable ".concat(value, " Alt Text Suggestions'"), {
                                        tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_NAME.image_alt_text_generator */ .vG.image_alt_text_generator,
                                        tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_optimization */ ._V.ai_content_optimization
                                    });
                                    (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .trackAnalyticsEvent */ .ec)({
                                        eventFor: "button",
                                        isAnonymousUser: !user,
                                        payload: {
                                            label: "Clicked Locked Option",
                                            component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                                            screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                                            tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_NAME.image_alt_text_generator */ .vG.image_alt_text_generator,
                                            tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_optimization */ ._V.ai_content_optimization,
                                            option_name: "".concat(value, " Alt Text Suggestion"),
                                            isQwaDashboard: isQwaDashboard
                                        }
                                    });
                                }
                            }
                        // setError('');
                        },
                        classes: classes
                    }),
                    !qttr_tools_auth && !user && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_google_recaptcha__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                className: classes.recaptcha,
                                sitekey: "6LfNnmAqAAAAAFm-6SDC8c9lFenCJX2_QkckWpsd",
                                onChange: handleRecaptchaChange
                            }),
                            (captchaError === null || captchaError === void 0 ? void 0 : captchaError.includes("recaptchaValue")) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                className: "red",
                                children: "Please complete the reCAPTCHA to verify you're human."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_SkipCaptcha__WEBPACK_IMPORTED_MODULE_12__/* .SkipCaptcha */ .h, {
                                classes: classes,
                                meta: {
                                    component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                                    screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                                    tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_NAME.image_alt_text_generator */ .vG.image_alt_text_generator,
                                    tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_optimization */ ._V.ai_content_optimization
                                },
                                setShowVerifyEmailPopup: setShowVerifyEmailPopup
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "".concat(isCreditsShown ? classes.creditsShown : classes.freeCreditsShown),
                        children: [
                            isCreditsShown ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_CreditsInfo__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                classes: classes,
                                creditsRemaining: creditsRemaining,
                                creditsNeeded: creditsNeeded,
                                usagePerDay: usagePerDay
                            }) : !isQwaDashboard || showFreeToolsUsage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_CreditsInfo__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                classes: classes,
                                creditsRemaining: freeToolsUsage,
                                creditsNeeded: creditsNeeded,
                                usagePerDay: isCorpEmail ? 10 : 7,
                                showFreeToolsUsage: showFreeToolsUsage
                            }) : null,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "d-flex ".concat(classes.buttonGroup),
                                style: {
                                    marginTop: "16px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                        style: {
                                            float: "right"
                                        },
                                        className: "".concat(classes.toolsYellowCTA, " ").concat(classes.toolsOutlinedCTA, " ").concat(classes.button),
                                        onClick: function() {
                                            setKeyword("");
                                            setDescription("");
                                            setGeneratedTitles("");
                                            setNumTags(3);
                                            setImageBase64("");
                                            setFileData("");
                                            setDropBoxError("");
                                            setError("");
                                        },
                                        children: "Clear"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                        className: "".concat(classes.toolsYellowCTA, " ").concat(classes.button),
                                        color: "primary",
                                        onClick: function() {
                                            return (0,_utility_common__WEBPACK_IMPORTED_MODULE_10__/* .handleGenerateOutput */ .jx$)(creditsRemaining, creditsNeeded, isQwaDashboard, session, qttr_tools_daypass_auth, setShowMinimumCreditsNeededMsg, setShowBuyOnePass, handleWriteTitleTag, _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .trackAnalyticsEvent */ .ec, freeToolsUsage, showFreeToolsUsage);
                                        },
                                        children: "Generate Alt Text"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ImageAltTextGenerator);


/***/ })

}]);